import Swiper, { A11y, FreeMode, Navigation } from 'swiper'

export const selector = '.carousel'

export default (el) => {
    const swiperEl = el
        && el.querySelector('.swiper')

    if (!swiperEl)
        return

    console.groupCollapsed('Carousel')

    const containerEl = el
        .querySelector('.swiper-container')

    const nextEl = el
        .querySelector('.swiper-button-next')

    const prevEl = el
        .querySelector('.swiper-button-prev')

    const swiper = new Swiper(swiperEl, {
        modules: [A11y, FreeMode, Navigation],
        freeMode: {
            enabled: true,
            sticky: true
        },
        navigation: {
            nextEl,
            prevEl
        },
        on: {
            init: () => {
                console.log('Swiper initialized')

                containerEl
                    && containerEl.classList.add('swiper-initialized')
            }
        },
        rewind: true,
        slidesPerView: 'auto',
        spaceBetween: 20,
        speed: 500,
        breakpoints: {
            768: {
                spaceBetween: 30
            },
            1400: {
                spaceBetween: 60
            }
        }
    })

    console.log(swiper)

    console.groupEnd()

    return swiper
}
